import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const NOTES_API_BASE = `${BACKEND_URL}/api`;

// Dedicated client for the Notes module. Sends the Notes token when present;
// otherwise falls back to the Inventique token so a signed-in Super Admin can
// drive Notes via the module toggle without a second login.
export const notesApi = axios.create({ baseURL: NOTES_API_BASE });

notesApi.interceptors.request.use((config) => {
  const nt = localStorage.getItem('notes_token');
  const it = localStorage.getItem('inv_token');
  const token = nt || it;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

notesApi.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err.response?.status;
    if (status === 401) {
      const path = window.location.pathname;
      const hasNotes = !!localStorage.getItem('notes_token');
      if (hasNotes) {
        // Notes session expired → back to the unified login.
        localStorage.removeItem('notes_token');
        localStorage.removeItem('notes_user');
        if (path.startsWith('/notes') && path !== '/notes/login') {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(err);
  }
);
